export default __webpack_public_path__ + "static/media/logo-no-text-halloween.e9b53fa1.svg";